module.exports = __webpack_public_path__ + "static/media/welcome.4eb5578d.png";